/**
 * Created by Ning Jiang on 2021-05-04.
 */
import {KarenParsedData} from "./KarenParsedData";
import {IKarenInitData, ISymbolValues} from "./IKarenData";
import {KarenDataParser} from "./KarenDataParser";

export class KarenParsedInitData extends KarenParsedData {

    public readonly betLines: number[][];
    public readonly symbolValues: ISymbolValues;
    public readonly isRestoreState: boolean;
    public readonly initReelSetName: string;
    public readonly gameAreaSize: number[];
    public readonly boostedBetPlayed: boolean;
    public readonly wasFeatureBuy: boolean;
    // To add Nudge Data
    public readonly doReelNudge: boolean;

    constructor(rawData: IKarenInitData, parser: KarenDataParser) {
        super(rawData, parser);
        this.betLines = rawData.betLines;
        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
        this.initReelSetName = parser.parseInitReelSet(rawData);
        this.gameAreaSize = rawData.gameAreaSize;
        this.boostedBetPlayed = rawData.boostedBetPlayed;
        this.wasFeatureBuy = rawData.wasFeatureBuy;
        this.doReelNudge = parser.calculateReelNudge(rawData);
    }

    protected parseScatterPositions(rawData: IKarenInitData): number[] | undefined {
        return rawData.scatterPositionsEnteringFreespin;
    }
}
